export * from "./fetch";
import { useAPI } from "../../utils/use-api";
import { Endpoint } from "../common/endpoints";
import { useInfiniteAPI, } from "../../utils/use-infinite-api";
import { useMutation } from "../../utils/use-mutation";
import { requiredActionAttachDocument, requiredActionCheckDocument, requiredActionConfirmDeposit, requiredActionSubmitAchDetails, } from "./fetch";
export const useRequiredActionList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.RequiredActionList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useInfiniteRequiredActionList = (queryParams, shouldMakeRequest, swrOptions) => {
    return useInfiniteAPI({
        endpoint: Endpoint.RequiredActionList,
        queryParams,
        shouldMakeRequest,
        swrOptions,
    });
};
export const useRequiredActionSelf = (requiredActionId, shouldMakeRequest, swrOptions) => {
    return useAPI({
        endpoint: Endpoint.RequiredActionSelf,
        endpointParams: { requiredActionId },
        shouldMakeRequest,
        swrOptions,
    });
};
export const useRequiredActionAttachDocument = (requiredActionId, params) => {
    return useMutation((body, queryParams, headers) => {
        return requiredActionAttachDocument(requiredActionId, body, queryParams, headers);
    }, params);
};
export const useRequiredActionCheckDocument = (requiredActionId, params) => {
    return useMutation((body, queryParams, headers) => {
        return requiredActionCheckDocument(requiredActionId, body, queryParams, headers);
    }, params);
};
export const useRequiredActionConfirmDeposit = (requiredActionId, params) => {
    return useMutation((body, queryParams, headers) => {
        return requiredActionConfirmDeposit(requiredActionId, body, queryParams, headers);
    }, params);
};
export const useRequiredActionSubmitAchDetails = (requiredActionId, params) => {
    return useMutation((body, queryParams, headers) => {
        return requiredActionSubmitAchDetails(requiredActionId, body, queryParams, headers);
    }, params);
};
